export interface LanguageConfig {
    code: string;
    name: string;
    nativeName: string;
    flag: string;
}

export const LANGUAGES: LanguageConfig[] = [
    { code: "pl", name: "Polish", nativeName: "Polski", flag: "🇵🇱" },
    { code: "en", name: "English", nativeName: "English", flag: "🇬🇧" },
];

export const DEFAULT_LANGUAGE = "pl";

export const getLanguageByCode = (code: string): LanguageConfig | undefined =>
    LANGUAGES.find((lang) => lang.code.toLowerCase() === code.toLowerCase());

export const getLanguageCodes = (): string[] =>
    LANGUAGES.map((lang) => lang.code);
